
        import 'CrapNav.f7d6fb8.css-module'
        export default {"CrapNav":"CrapNav_CrapNav_f7d6fb8","signUpButton":"signUpButton_CrapNav_f7d6fb8"}
    